import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42459929"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Simulatore qualifica", -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-3" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Punti totali", -1))
const _hoisted_7 = { class: "col-sm-3" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Punti mensili", -1))
const _hoisted_10 = { class: "col-sm-3" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Punti trimestrali", -1))
const _hoisted_13 = { class: "col-sm-3" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Punti semestrali", -1))
const _hoisted_16 = { class: "col-sm-3" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Punti annuali", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-sm-3" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Calcola qualifica annuale", -1))
const _hoisted_24 = { class: "col-sm-3" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Calcola qualifica semestrale", -1))
const _hoisted_27 = { class: "col-sm-3" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Calcola qualifica trimestrale", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-sm-12" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Qualifica provvigioni attuale", -1))
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "col-sm-3" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Qualifica:", -1))
const _hoisted_38 = { class: "col-sm-3" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Euro per punto:", -1))
const _hoisted_40 = { class: "col-sm-3" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Punti necessari:", -1))
const _hoisted_42 = { class: "col-sm-3" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Modalita calcolo:", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_45 = { class: "text-right" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "number",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vm.puntiTotali) = $event))
            }, null, 512), [
              [_vModelText, _ctx.vm.puntiTotali]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              type: "number",
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vm.puntiMensili) = $event))
            }, null, 512), [
              [_vModelText, _ctx.vm.puntiMensili]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("input", {
              type: "number",
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vm.puntiTrimestrali) = $event))
            }, null, 512), [
              [_vModelText, _ctx.vm.puntiTrimestrali]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _withDirectives(_createElementVNode("input", {
              type: "number",
              class: "form-control",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.vm.puntiSemestrali) = $event))
            }, null, 512), [
              [_vModelText, _ctx.vm.puntiSemestrali]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _withDirectives(_createElementVNode("input", {
              type: "number",
              class: "form-control",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.vm.puntiAnnuali) = $event))
            }, null, 512), [
              [_vModelText, _ctx.vm.puntiAnnuali]
            ])
          ])
        ])
      ]),
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: "form-control",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.vm.annuale) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.vm.annuale]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: "form-control",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.vm.semestrale) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.vm.semestrale]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: "form-control",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.vm.trimestrale) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.vm.trimestrale]
            ])
          ])
        ])
      ]),
      _hoisted_30,
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedProvvigioni) = $event)),
              onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onSelectedProvvigioniChange && _ctx.onSelectedProvvigioniChange(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.provvigioniConfig, (item, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: i,
                  value: item
                }, _toDisplayString(item.codiceQualifica), 9, _hoisted_35))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.selectedProvvigioni]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("div", null, [
            _createElementVNode("b", null, _toDisplayString(_ctx.vm.qualificaAttuale.codiceQualifica), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("b", null, _toDisplayString(_ctx.vm.qualificaAttuale.euroPerPunto), 1)
        ]),
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createElementVNode("b", null, _toDisplayString(_ctx.vm.qualificaAttuale.puntiTotaliNecessari), 1)
        ]),
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("b", null, _toDisplayString(_ctx.vm.qualificaAttuale.modalitaCalcolo), 1)
        ])
      ]),
      _hoisted_44,
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-success",
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.calculate && _ctx.calculate(...args)))
        }, " Calcola ")
      ]),
      _hoisted_46,
      _createElementVNode("pre", null, "                " + _toDisplayString(_ctx.result) + "\r\n            ", 1)
    ])
  ]))
}